import React, { FC } from 'react';
import { ui, button } from 'util/ui';

/** The rounded white box every Admin › Settings section sits in (Aaron, 5 Nov 2026: all the same). */
export const SettingsCard: FC<{ id: string; title: string; note?: React.ReactNode }> = ({ id, title, note, children }) => (
  <section
    aria-labelledby={id}
    style={{ background: ui.surface, border: `1px solid ${ui.line}`, borderRadius: 16, padding: '18px 20px 20px', marginBottom: 20, fontFamily: ui.font, color: ui.ink }}
  >
    <h2 id={id} style={{ margin: '0 0 4px', fontSize: 17, fontWeight: 700 }}>
      {title}
    </h2>
    {note && <p style={{ margin: '0 0 16px', fontSize: 13, color: ui.muted }}>{note}</p>}
    {children}
  </section>
);

/** A box's own Save button, bottom left, with its result beside it. */
export const SaveRow: FC<{ onSave(): void; busy?: boolean; disabled?: boolean; message?: string; label?: string; busyLabel?: string }> = ({
  onSave,
  busy,
  disabled,
  message,
  label = 'Save',
  busyLabel = 'Saving…',
  children,
}) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 18, flexWrap: 'wrap' }}>
    <button
      type="button"
      className="archy-btn"
      style={{ ...button('primary'), height: 40, opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : busy ? 'wait' : 'pointer' }}
      onClick={onSave}
      disabled={busy || disabled}
    >
      {busy ? busyLabel : label}
    </button>
    {children}
    {message && (
      <span role="status" style={{ fontSize: 13, color: ui.muted }}>
        {message}
      </span>
    )}
  </div>
);

export const fieldLabel: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, fontWeight: 600, color: ui.text2 };

export const textInput: React.CSSProperties = {
  height: 44,
  border: `1px solid ${ui.control}`,
  borderRadius: 10,
  padding: '0 12px',
  font: 'inherit',
  fontSize: 14,
  fontWeight: 400,
  width: '100%',
  boxSizing: 'border-box',
  background: ui.surface,
  color: ui.ink,
};
